export function getDefaultBrandedUrl(slug: string): string {
  return `open1031.ai/o/${slug}/login`
}
